<template>
  <v-navigation-drawer
    v-model="drawer"
    color="bg_darker"
    :mini-variant.sync="drawer"
    permanent
    fixed
    clipped
    dark
    :style="navHeight">
    <v-list nav>
      <div v-if="system.offline">
        <v-list-item
          link
          @click.stop="$router.push({ name: 'playbook' }); drawer = true;">
          <v-list-item-icon title="Home">
            <v-icon v-text="mdiViewDashboardOutline" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-light" v-html="'Playbook Home'" />
          </v-list-item-content>
        </v-list-item>

        <v-list-item link @click.stop="$router.push({ name: 'faqs' })">
          <v-list-item-icon title="FAQs">
            <v-icon v-text="mdiFrequentlyAskedQuestions" />
          </v-list-item-icon>
          <v-list-item-content>
            <v-list-item-title class="font-weight-light" v-html="'FAQs'" />
          </v-list-item-content>
        </v-list-item>
        <v-divider class="my-2"></v-divider>
      </div>

      <v-list-item
        v-for="page in pages"
        :key="page.title"
        link
        @click.stop="$router.push({ name: page.nav }); drawer = true;">
        <v-list-item-icon :title="page.title2">
          <v-icon v-text="page.icon" />
        </v-list-item-icon>
        <v-list-item-content>
          <v-list-item-title class="font-weight-light" v-html="page.title" />
        </v-list-item-content>
      </v-list-item>
    </v-list>

    <template v-slot:append>
      <v-list-item @click="drawer = !drawer" title="Expand Side Nav">
        <v-list-item-icon>
          <v-icon v-if="drawer" v-text="mdiChevronTripleRight" />
          <v-icon v-else v-text="mdiChevronTripleLeft" />
        </v-list-item-icon>
      </v-list-item>
    </template>
  </v-navigation-drawer>
</template>

<script>
import {
  mdiViewDashboardOutline,
  mdiCrownOutline,
  mdiAbacus,
  mdiStrategy,
  mdiSwordCross,
  mdiShieldHalfFull,
  mdiFrequentlyAskedQuestions,
  mdiChevronTripleRight,
  mdiChevronTripleLeft
} from '@mdi/js';

export default {
  name: 'sideNav',
  inject: ['system'],
  data() {
    return {
      mdiViewDashboardOutline,
      mdiCrownOutline,
      mdiAbacus,
      mdiStrategy,
      mdiSwordCross,
      mdiShieldHalfFull,
      mdiFrequentlyAskedQuestions,
      mdiChevronTripleRight,
      mdiChevronTripleLeft,
      drawer: true,
      navHeight: 'top: 48px; height: calc(100vh - 80px);',
      pages: [
        {
          title: 'Penetration Testing Plays',
          nav: 'plays',
          icon: mdiCrownOutline,
          title2: 'DWS Plays'
        },
        {
          title: 'CAPEC&trade;',
          nav: 'capecs',
          icon: mdiAbacus,
          title2: 'CAPEC™'
        },
        {
          title: 'MITRE ATT&amp;CK&reg;',
          nav: 'techniques',
          icon: mdiStrategy,
          title2: 'MITRE ATT&CK®'
        },
        {
          title: 'NIST SP 800-53 (Rev. 5)',
          nav: 'controls',
          icon: mdiSwordCross,
          title2: 'NIST SP 800-53 (Rev. 5)'
        },
        {
          title: 'CWE&trade;',
          nav: 'cwes',
          icon: mdiShieldHalfFull,
          title2: 'CWE™'
        }
      ]
    }
  },
  created() {
    if (this.system.offline) {
      this.navHeight = 'top: 24px; height: calc(100vh - 56px);';
    }
  }
};
</script>
